import salaryService from 'ApiService/Accountant/salaryService';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import SalaryModal from '../Models/SalaryModal';

const Index = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [employeeType, setEmployeeType] = useState('Admin');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [currentSalary, setCurrentSalary] = useState('');
  const [bankDetails, setBankDetails] = useState({
    accountNumber: '',
    ifscCode: '',
    bankName: '',
  });
  const { state } = useContext(AuthContext);
  const navigate = useNavigate();

  function reset() {
    setFilteredData(data);
    setSearchTerm('');
    setEmployeeType('Admin');
    fetchUserData('Admin');
  }

  const fetchUserData = async () => {
    setLoading(true);
    setData([]);
    setFilteredData([]);

    try {
      const selectedBranch = state?.selectedBranch || '';
      const response = await salaryService.getEmployee(
        employeeType,
        selectedBranch
      );

      if (response.data.success) {
        const employees = response.data.employees || [];
        setData(employees);
        setFilteredData(employees);

        // Move this outside the if block to ensure it runs
        if (!employees || employees.length === 0) {
          toast.error(`No data found for ${employeeType} users in this branch`);
        }
      } else {
        toast.error('Failed to fetch employee data');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'An error occurred while fetching data'
      );
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [employeeType, state?.selectedBranch]);

  useEffect(() => {
    let result = data;
    if (searchTerm) {
      result = data.filter(
        (user) =>
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(result);
  }, [data, searchTerm]);

  const handleEmployeeTypeChange = (e) => {
    setEmployeeType(e.target.value);
  };
  const handleOpenModal = (employee) => {
    setSelectedEmployee(employee);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEmployee(null);
    setCurrentSalary('');
    setBankDetails({ accountNumber: '', ifscCode: '', bankName: '' });
  };

  return (
    <div className="mt-4 h-full w-full md:mt-4">
      {loading ? (
        <div className="flex h-40 items-center justify-center">
          <ThreeDots color="#5431ed" className="mt-100" />
        </div>
      ) : (
        <>
          <h3 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white ">
            Employee Salary Management (Create and view salary)
          </h3>
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <div className="w-full sm:w-[300px] ">
              <div className="w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                <select
                  className="text-lightFourth w-full rounded-xl pr-4 text-sm outline-none dark:!bg-navy-800 dark:text-white"
                  value={employeeType}
                  onChange={handleEmployeeTypeChange}
                >
                  <option value="Admin">Admin</option>
                  <option value="Account">Accountant</option>
                  <option value="Placement">HRs</option>
                  <option value="Teacher">Teacher</option>
                </select>
              </div>
            </div>

            <div className="w-full rounded-xl border border-gray-200 bg-lightPrimary py-2.5 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
              <input
                type="text"
                placeholder="Search Employee...."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-800 dark:text-white"
              />
            </div>
          </div>
          <div className="mt-[14px] h-full w-full overflow-x-scroll 2xl:overflow-x-hidden">
            <table className="w-full font-dm">
              <thead className="w-full">
                <tr className="items-center border-b border-gray-200 dark:border-white/10">
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">Sr No.</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">USER NAME</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">EMAIL</div>
                  </th>
                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">SALARY</div>
                  </th>

                  <th className="px-[27px] pb-[12px] pt-[32px] text-start text-xs tracking-wide text-gray-600">
                    <div className="text-xs font-bold">ACTIONS</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <tr
                      className="items-center border-b border-gray-200 dark:border-white/10"
                      key={index}
                    >
                      <td className="mt-[20px] px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {index + 1}
                        </div>
                      </td>
                      <td className="mt-[20px] px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.name}
                        </div>
                      </td>
                      <td className="mt-[20px] px-4 px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.email}
                        </div>
                      </td>
                      <td className="mt-[20px] px-4 px-[27px] py-[16px]">
                        <div className="w-full text-start font-medium text-navy-700 dark:text-white">
                          {row.salary || 'n/a'}
                        </div>
                      </td>

                      <td className="mt-[20px] px-4 px-[27px] py-[16px]">
                        <button
                          className="rounded-xl bg-blue-500 px-4 py-2 text-sm font-bold text-white"
                          onClick={() => handleOpenModal(row)}
                        >
                          {row.salary ? 'View Salary' : 'Create Salary'}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="py-4 text-center text-gray-500">
                      <Nodatafound title={`No ${employeeType} data found`} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {isModalOpen && (
            <SalaryModal
              employee={selectedEmployee}
              onClose={handleCloseModal}
              onSalaryCreated={fetchUserData}
              employeeType={employeeType}
              selectedEmployee={selectedEmployee}
              handleCloseModal={handleCloseModal}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Index;
